

























import Vue from "vue";

import IconRocket from "@joyz/app-core/assets/icons/default/Rocket.svg";

import { GET_STT_CONNECTION_METHOD_OPTIONS } from "@tt-app/constants";
import { FormOptions, UseOnlyHttp } from "@tt-app/models";

interface State {
  model: boolean;
}

interface Computed {
  options: FormOptions<boolean>[];
  iconTitle: string;
}

interface Props {
  useOnlyHttp: UseOnlyHttp;
}

export default Vue.extend<State, {}, Computed, Props>({
  name: "SttConnectionMethodCard",

  props: {
    useOnlyHttp: { type: Boolean, required: true }
  },

  data() {
    return { model: this.useOnlyHttp };
  },

  computed: {
    options() {
      const recommendedOption = 0;
      return GET_STT_CONNECTION_METHOD_OPTIONS(this, recommendedOption);
    },
    iconTitle: () => IconRocket
  }
});
